import React from 'react'
import { components } from 'onfsspacommon'
import Joi from 'joi'
import 'onfsspacommon/dist/index.css'
import { getCCPAContent } from '../services/CMSService'

import DOMPurify from 'dompurify'

const { sanitize } = DOMPurify

const { OnfsForm } = components

export default class PrivacyForm extends OnfsForm {
  componentDidMount() {
    const contentResponse = getCCPAContent()

    contentResponse
      .then(({ contactContentHTML, companyName, headingContentHTML }) => {
        const CMS = {
          headerContent: sanitize(headingContentHTML),
          contactContent: sanitize(contactContentHTML)
        }
        this.setState({ CMS })
        this.setState({ companyName })
      })
      .catch((badRes) => console.log(`Bad CCPA CMS Data response -- ${badRes}`))
  }

  state = {
    data: {
      firstName: '',
      middleName: '',
      lastName: '',
      maidenName: '',
      street: '',
      city: '',
      state: '',
      zip: '',
      phone: '',
      dob: '',
      policyNumbers: '',
      wantsPersonalInfoA: false,
      correctPersonalInfo: false,
      wantInfoDeleted: false,
      limitUseDisclosureSensitive: false,
      wantsOptedOutOfSale: false,
      contactNotes: ''
    },
    requestingAtLeastOneItem: false,
    wasSubmitted: false,
    needsToClickOnFormLink: false,
    didClickOnFormLink: false,
    CMS: { headerContent: '', contactContent: '' },
    companyName: 'our company',
    errors: {}
  }

  schema = Joi.object({
    firstName: Joi.string().allow('').label('First Name'),
    middleName: Joi.string().allow('').label('Middle Name'),
    lastName: Joi.string().allow('').label('Last Name'),
    maidenName: Joi.string().allow('').label('Maiden/Nickname'),
    street: Joi.string().allow('').label('Street Address'),
    city: Joi.string().allow('').label('City'),
    state: Joi.string().allow('').label('State'),
    zip: Joi.string()
      .allow('')
      .pattern(/^\d{5}(?:[-\s]\d{4})?$/)
      .error(() => new Error('Must be a valid ZIP code'))
      .label('ZIP'),
    phone: Joi.string()
      .pattern(/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im)
      .allow('')
      .error(() => new Error('Must be a valid phone number'))
      .label('Phone Number'),
    dob: Joi.string().allow('').label('Date of Birth'),
    policyNumbers: Joi.string()
      .allow('')
      .label('Policy/Contract number(s), if applicable:'),
    wantsPersonalInfoA: Joi.boolean().truthy('true').falsy('false').label('1'),
    correctPersonalInfo: Joi.boolean().truthy('true').falsy('false').label('2'),
    wantInfoDeleted: Joi.boolean().truthy('true').falsy('false').label('3'),
    limitUseDisclosureSensitive: Joi.boolean().truthy('true').falsy('false').label('4'),
    wantsOptedOutOfSale: Joi.boolean().truthy('true').falsy('false').label('5'),
    contactNotes: Joi.string().required().label('Contact Method')
  })

  doSubmit = () => {
    this.setState({ wasSubmitted: true })
    this.setState({
      needsToClickOnFormLink: this.state.data.wantsPersonalInfoA === true
    })

    const inputs = document
      .getElementById('requestedInfoContainer')
      .getElementsByTagName('input')

    this.setState({ requestingAtLeastOneItem: false })
    for (let i = 0; i < inputs.length; i++) {
      if (inputs[i].value === 'true') {
        this.setState({ requestingAtLeastOneItem: true })
      }
    }

    setTimeout(() => {
      if (this.state.requestingAtLeastOneItem) {
        if (this.state.needsToClickOnFormLink) {
          if (this.state.didClickOnFormLink) {
            // Call the server
            this.props.submit(this.state.data)
          }
        } else {
          // Call the server
          this.props.submit(this.state.data)
        }
      }
    }, 0)
  }

  render() {
    return (
      <div className='container'>
        {/*** CMS Div Placeholder ***/}
        <div
          dangerouslySetInnerHTML={{
            __html: this.state.CMS.headerContent
          }}
        />

        {this.renderForm(
          <>
            {this.renderInput({
              name: 'firstName',
              label: 'First Name'
            })}
            {this.renderInput({
              name: 'middleName',
              label: 'Middle Name'
            })}
            {this.renderInput({
              name: 'lastName',
              label: 'Last Name'
            })}
            {this.renderInput({
              name: 'maidenName',
              label: 'Maiden/Nickname'
            })}
            {this.renderInput({
              name: 'street',
              label: 'Street Address'
            })}
            {this.renderInput({
              name: 'city',
              label: 'City'
            })}
            {this.renderSelect({
              name: 'state',
              label: 'State',
              type: 'states'
            })}
            {this.renderInput({
              name: 'zip',
              label: 'ZIP'
            })}
            {this.renderInput({
              name: 'phone',
              label: 'Phone Number'
            })}
            {this.renderInput({
              name: 'dob',
              label: 'Date of Birth',
              type: 'date'
            })}
            {this.renderInput({
              name: 'policyNumbers',
              label: 'Policy/Contract number(s), if applicable:',
              placeholder: 'Enter Policy Number(s)'
            })}
            <Separator />
            <h3>
              The CCPA grants consumers the right to (check all that you are
              requesting):
            </h3>
            <div
              id={'requestedInfoContainer'}
              onFocus={() => this.setState({ wasSubmitted: false })}
            >
              {this.renderInput({
                name: 'wantsPersonalInfoA',
                label: (
                    <div style={normalFontWeight}>
                      1. <b> Request to Know and Access My Personal Information. </b>
                    </div>
                ),
                type: 'checkbox'
              })}
              {this.renderInput({
                name: 'correctPersonalInfo',
                label: (
                    <div style={normalFontWeight}>
                      2. <b>Request to Correct My Personal Information. </b>
                    </div>
                ),
                type: 'checkbox'
              })}
              {this.renderInput({
                name: 'wantInfoDeleted',
                label: (
                  <div style={normalFontWeight}>
                    3. <b>Request to Delete My Personal Information. </b>
                  </div>
                ),
                type: 'checkbox'
              })}
              {this.renderInput({
                name: 'limitUseDisclosureSensitive',
                label: (
                    <div style={normalFontWeight}>
                      4. <b>Request to Limit Use and Disclosure of Sensitive Personal Information. </b>
                    </div>
                ),
                type: 'checkbox'
              })}
              {this.renderInput({
                name: 'wantsOptedOutOfSale',
                label: (
                  <div style={normalFontWeight}>
                    5. <b>Request to Opt-Out of the Sale of My Personal Information.</b>
                  </div>
                ),
                type: 'checkbox'
              })}
              {this.state.wasSubmitted &&
                !this.state.requestingAtLeastOneItem && (
                  <div className={'alert alert-danger'}>
                    You must check at least one CCPA Request Option.
                  </div>
                )}
            </div>
            <Separator />

            {/*** CMS Div ***/}
            <div
              dangerouslySetInnerHTML={{
                __html: this.state.CMS.contactContent
              }}
            />

            {this.renderInput({
              name: 'contactNotes',
              label: '',
              type: 'textarea',
              placeholder: 'How should we contact you?'
            })}
            {this.state.data.wantsPersonalInfoA === true && (
              <React.Fragment>
                <Separator />
                <h3>Declaration</h3>
                <p>
                  <b>
                    Note: This section must be completed only if you are making
                    a request to know and access your personal information above.
                  </b>
                </p>
                <p>
                  Please sign this{' '}
                  <a
                    href={process.env.PUBLIC_URL + '/declaration.pdf'}
                    target='_blank'
                    rel='noopener noreferrer'
                    onClick={() => this.setState({ didClickOnFormLink: true })}
                  >
                    declaration
                  </a>{' '}
                  and mail it to us at Ohio National Financial Services, Attn:
                  Legal, One Financial Way, Cincinnati, OH 45242, or e-mail a
                  copy of it to us at legal@ohionational.com.
                </p>
                {!this.state.didClickOnFormLink && this.state.wasSubmitted && (
                  <div className={'alert alert-danger'}>
                    If you request to know and access your personal information, you must mail or email us the
                    declaration above. To continue, please click on the form
                    link above.
                  </div>
                )}
              </React.Fragment>
            )}
            {this.renderSubmitButton('Submit Request')}
          </>
        )}
      </div>
    )
  }
}

const normalFontWeight = { fontWeight: 'normal' }

function Separator() {
  return <hr style={{ borderTopColor: 'black' }} />
}
